import './report-featured-card.scss'

import { faExclamationTriangle, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { ItemDataStore, itemSelectors } from '@skinsoft/entity';
import { ReportFeatured } from '@skinsoft/entity-ui';
import { ConditionReportPDFTransferHelper } from '@skinsoft/media-transfer-helper';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { ActionType, SearchFeatured, States, TitleClickAction, Touchable, getTranslatedString } from '@skinsoft/ui';
import { take } from 'rxjs/operators';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { Media } from '../item-card/media';
import { DISPLAY_ALERT_TOPIC } from '@skinsoft/bus/src/busTopics';
import _ from 'lodash';

@Component({
    components: {
        sMedia: Media,
        sTouchable: Touchable,
    },
    props: ['reportFeatured', 'targetRouteName', 'titleClickAction'],
    template: require('./report-featured-card.html')
})
export class ReportfeaturedCard extends ReactiveVue {

    public reportFeatured: ReportFeatured;
    public targetRouteName: string;
    private titleClickAction: TitleClickAction

    private state: States = States.PENDING;
    private concernedItemSummary: string = "";

    private $itemDataStore: ItemDataStore;
    private $conditionReportPDFTransferHelper: ConditionReportPDFTransferHelper;

    public editIcon = faExternalLinkAlt

    // Icons
    private warningIcon = faExclamationTriangle;

    public isReady() {
        return this.state === States.READY;
    }

    private async openReportDocument() {
        const response = await this.$conditionReportPDFTransferHelper.downloadOriginalPDFFile(this.reportFeatured.firstMedia).toPromise()
        const fileName = `${this.reportFeatured.referenceNumber}.pdf`;
        // Notify dl success
        if (response) {
            this.download(fileName, response)
            this.emitOnBus(DISPLAY_ALERT_TOPIC, {
                message: this.$t('listReportScreen.closed.downloadSuccess', { docTitle: fileName }),
                variant: "success"
            })

        }
        // Notify dl failure 
        else {
            this.emitOnBus(DISPLAY_ALERT_TOPIC, {
                message: this.$t('listReportScreen.closed.downloadFailure'),
                variant: "danger"
            })
        }
    }

    /**
     * Launches the downloading of a file
     * @param fileName 
     * @param text 
     */
    private download(fileName, text: string) {

        const data = window.URL.createObjectURL(text)
        const element = document.createElement('a')
        element.style.display = 'none'
        element.href = data;
        element.setAttribute('download', fileName)
        document.body.appendChild(element)
        element.click()
        document.body.removeChild(element)

        setTimeout(() => {
            window.URL.revokeObjectURL(data);
        }, 100);

    }

    /**
     * Go to edit report view
     */
    private editReport(reportId, route = this.targetRouteName) {
        // delay to let button animation occure
        setTimeout(() => {
            this.$router.push(
                {
                    name: route,
                    params: {
                        reportId
                    },
                });
        }, 300);
    }

    private onTitleClicked() {
        if(this.titleClickAction && this.titleClickAction.action === ActionType.EDIT){
            this.editReport(this.reportFeatured.id, this.titleClickAction.targetRouteName)
        }
    }

    private buildConcernedItemSummary() {
        const itemId = this.reportFeatured.involvedItem;
        if (itemId) {
            this.subscribeTo(this.$itemDataStore.fetchOne(itemId).pipe(take(1)),
                (item) => {
                    this.concernedItemSummary = itemSelectors.identifier(item, this.$i18n.locale);
                    const itemTitle = itemSelectors.title(item, this.$i18n.locale) as string;
                    if (itemTitle) {
                        this.concernedItemSummary += `(${itemTitle})` as string;
                    }
                },
                'concerned-item'
            )
        }
    }

    private get reportReason(): string {
        return getTranslatedString(_.get(this.reportFeatured.reportReason, 'secondaryValue'), this.$i18n.locale)
    }

    @Watch('reportFeatured', { immediate: true, deep: true })
    private onReportFeaturedChange(reportFeatured: SearchFeatured) {
        this.unsubscribeFrom('concerned-item');
        this.state = reportFeatured ? States.READY : States.PENDING;
        if (reportFeatured) {
            this.buildConcernedItemSummary();
        }
    }
}